import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { BlogListItem } from '../../shared/models/blog.models';

@Component({
  selector: 'app-marketing-blog-card',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <article class="cg-blog-card">
      <a [routerLink]="['/blog', post.slug]" class="cg-blog-card__link">
        @if (post.featuredImage?.cdnUrl) {
          <div class="cg-blog-card__media">
            <img
              [src]="post.featuredImage!.cdnUrl"
              [alt]="post.featuredImage!.alt || post.title"
              loading="lazy"
              width="640"
              height="360"
            />
          </div>
        }
        <div class="cg-blog-card__body">
          @if (post.categories.length) {
            <span class="cg-blog-card__category">{{ post.categories[0].name }}</span>
          }
          <h3 class="cg-blog-card__title">{{ post.title }}</h3>
          <p class="cg-blog-card__excerpt">{{ post.excerpt }}</p>
          <div class="cg-blog-card__meta">
            @if (post.author) {
              <span>{{ post.author.displayName }}</span>
            }
            @if (post.publishedAt) {
              <time [dateTime]="post.publishedAt">{{ formatDate(post.publishedAt) }}</time>
            }
            <span>{{ post.readingTimeMinutes }} min read</span>
          </div>
        </div>
      </a>
    </article>
  `,
})
export class MarketingBlogCardComponent {
  @Input({ required: true }) post!: BlogListItem;

  formatDate(iso: string): string {
    return new Date(iso).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
}
